'use client';

import type {TextSectionFragmentType} from '@/components/content-blocks/text-section/query';
import {ImageGallery} from '@/components/image-gallery';

export type PortableTextGalleryProps = Extract<
	NonNullable<TextSectionFragmentType['content']>[number],
	{_type: 'portableTextGallery'}
>;

export const PortableTextGallery = (props: PortableTextGalleryProps) => {
	const {images} = props ?? {};

	if (!images || images.length === 0) {
		return null;
	}

	return (
		<div className="my-8">
			<ImageGallery images={images} aspectRatio={props.aspectRatio} />
		</div>
	);
};
